<template>
  <component :is="layout">
    <router-view />
  </component>
</template>
<script lang="ts">
import {defineComponent} from "vue";
export default defineComponent({
  async created() {
    const {pathname, href} = document.location;
    const isNotAuth = ["/policy", "/widget", "/"];
    const quiz =
      !pathname.includes("/quiz/setting") &&
      pathname != "/quiz" &&
      pathname.includes("/quiz");
    const customDomein = !(
      href.includes("localhost") || href.includes("readds.ru")
    );
    if (isNotAuth.includes(pathname) || quiz || customDomein) {
      return;
    }

    if (pathname != "/authorization" && pathname != "/registration") {
      if (!localStorage.getItem("keyUserAuth")) {
        this.$router.push("/authorization");
        return;
      }
      await this.$userStore.fetchUser();
    } else {
      if (localStorage.getItem("keyUserAuth")) {
        this.$router.push("/setting");
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    }
  }
});
</script>
<style>
.selectArrow {
  position: absolute;
  height: 10px !important;
  width: 10px !important;
  left: calc(100% - 15px);
  top: calc(50% + 20px);
  z-index: 20;
  opacity: 0.5;
  background-image: url("$images/arrowSelectW.svg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 10;
}
</style>
